export default "/app/global-wrapper-client/static/e872d1202094242343d8e8448cefc952.woff2";